import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-dialog-yes-no',
  templateUrl: './dialog-yes-no.component.html',
  styleUrls: ['./dialog-yes-no.component.css']
})
export class DialogYesNoComponent implements OnInit {
	msg: any;
	yesText: any;
	noText: any;
	showYes: boolean = true;

	constructor(
		public dialogRef: MatDialogRef<DialogYesNoComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.msg = data.msg;
		this.yesText = data.yesText;
		this.noText = data.noText;	

		if(data.showNo!=null){
			this.showYes = data.showYes;
		}
		else{
			this.showYes = true;
		}		
	}

	ngOnInit() {

	}

	answerClick(answer){
		this.dialogRef.close(answer);
	}
}
